import { ENTER, ENTERED, ENTERING, EXIT, EXITED, EXITING, } from "./constants";
/**
 *
 * @internal
 */
export function getNextStage(stage) {
    switch (stage) {
        case ENTER:
            return ENTERING;
        case ENTERING:
            return ENTERED;
        case EXIT:
            return EXITING;
        case EXITING:
            return EXITED;
        default:
            return stage;
    }
}
//# sourceMappingURL=getNextStage.js.map